import { useSearchParams } from 'react-router-dom'
import { AuthFlow } from '@features/web-auth'
import { ROUTES } from '@shared/config/routes'
import logoUrl from '@/assets/images/logo.svg'
import styles from './AuthPage.module.css'

/**
 * Страница /auth — обёртка над AuthFlow, читает ?redirect= из query.
 */
export const AuthPage = () => {
  const [params] = useSearchParams()
  const redirect = params.get('redirect') || ROUTES.HOME

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <img src={logoUrl} alt="Secret Chat" className={styles.logo} />
        <div className={styles.content}>
          <AuthFlow redirectTo={redirect} />
        </div>
      </div>
    </div>
  )
}

export default AuthPage
